<template>
	<div id="user-access-page" :class="placedBackg">

		<div :class="container">
			<div class="row mx-0 flex-center-xy page-size">

				<div class="form-container">
					
					<div class="box-color"><i><u class="fas fa-user"></u></i></div>

					<b-form class="form" @submit.prevent="login()" v-if="mode=='login'">
	
						<slot name="default"></slot>

						<h6 class="mb-3">Iniciar sesión</h6>
						<hr class="c-hr" />

						<b-form-group>
							<b-form-input type="email" v-model="form.email" required placeholder="Correo electrónico">
							</b-form-input>
						</b-form-group>

						<b-form-group>
							<b-form-input type="password" v-model="form.password" required placeholder="Contraseña">
							</b-form-input>
						</b-form-group>

						<p class="mb-3 text-center">
							<router-link v-if="!hideLinks" to="/registrarse">Crear cuenta</router-link>
							<b-form-group class="mt-3">
								<b-button type="submit" class="btn-blue" v-if="!isProcessing" variant="primary">Acceder</b-button>
								<b-button disabled class="btn-blue" v-else variant="primary">Procesando...</b-button>
							</b-form-group>
							<div class="text-center" @click="mode = 'recoverLink'">
								<span class="btn btn-link">
									¿Olvidó su contraseña?
								</span>
							</div>
						</p>

					</b-form>

					<div v-else-if="mode=='recoverLink'" class="form">
						<password-recovery @passwordUpdated="mode = 'login'"/>
						<p class="mb-3 text-center">
							<div class="text-center" @click="mode = 'login'">
								<span class="btn btn-link">
									Recordé mi contraseña
								</span>
							</div>
						</p>
					</div>

				</div>

			</div>
		</div>

		<sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modal">
			<div class="fa-3x" v-if="modal.icon == ''"><i class="fas fa-spinner fa-pulse"></i></div><br />
			{{ modal.msg }}
			<div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
				<b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close();">OK</b-button>
			</div>
		</sweet-modal>

	</div>
</template>

<script>
	import {mapActions} from 'vuex'
	import { notify } from '../../../utils';
	import mobiscroll from '@mobiscroll/javascript';

	export default {

		props: {
			hideLinks: {
				type: Boolean,
				default: false
			},
			loggedEvent: {
				type: String,
				default: 'logged'
			},
			avoidRedirectOnLogin: {
				type: Boolean,
				default: false
			},
			container: {
				type: String,
				default: 'container'
			},
			placedBackg: {
				type: String,
				default: 'placed-backg'
			}
		},

		data() {
			return {
				isProcessing: false,
				mode: 'login', // 'login', 'recoverLink'

				form: {
					email: '',
					password: ''
				},

				modal: {
					msg: '',
					icon: '',
					block: false,
				},
			}
		},

		methods: {
			...mapActions(['authTryLogin']),

			async login(){
				this.isProcessing = true;
				try {
					let response = await this.authTryLogin(this.form)
					this.$emit(this.loggedEvent, response)
					if(response.status && !this.avoidRedirectOnLogin)
						this.$router.replace('/usuario/mis-datos')
					
				} catch(e){
					console.error(e)
					notify(e)
				}
				this.isProcessing = false;
			},

			handleErrors (errors) {
				var err = "";

				if (errors.response) {
					if (errors.response.data.errors) {
						jQuery.each(errors.response.data.errors, (k, v) => {
							err += "*" + v[0] + "\n";
						});
					}
				}
				else {
					console.log(errors);
					err = "Error desconocido.";
				}

				this.modal.icon = "error";
				this.modal.msg = err;
				this.modal.block = false;
				this.$refs.modal.open();

			}
		}
	}
</script>
